module.exports = __webpack_public_path__ + "static/media/expense_other.37f451fa.svg";